var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Standard } from '../../../models/standard';
var SelectedStandardComponent = /** @class */ (function () {
    function SelectedStandardComponent() {
        this.hideDismiss = false;
        this.standard = Input('standard');
        this.dismissImageText = 'Dismiss selected standard.';
        this.dismissResult = new EventEmitter();
    }
    SelectedStandardComponent.prototype.dismissSelected = function () {
        this.dismissResult.emit(this.standard);
    };
    __decorate([
        Input(),
        __metadata("design:type", Standard)
    ], SelectedStandardComponent.prototype, "standard", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], SelectedStandardComponent.prototype, "hideDismiss", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], SelectedStandardComponent.prototype, "dismissResult", void 0);
    SelectedStandardComponent = __decorate([
        Component({
            selector: 'selected-standard',
            template: require('./selected-standard.component.html'),
            styles: [require('./selected-standard.component.scss')]
        }),
        __metadata("design:paramtypes", [])
    ], SelectedStandardComponent);
    return SelectedStandardComponent;
}());
export { SelectedStandardComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VsZWN0ZWQtc3RhbmRhcmQuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2VsZWN0ZWQtc3RhbmRhcmQuY29tcG9uZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxZQUFZLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFFdkUsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLDBCQUEwQixDQUFDO0FBUXBEO0lBT0k7UUFMZ0IsZ0JBQVcsR0FBWSxLQUFLLENBQUM7UUFNekMsSUFBSSxDQUFDLFFBQVEsR0FBRyxLQUFLLENBQUMsVUFBVSxDQUFDLENBQUM7UUFDbEMsSUFBSSxDQUFDLGdCQUFnQixHQUFHLDRCQUE0QixDQUFDO1FBQ3JELElBQUksQ0FBQyxhQUFhLEdBQUcsSUFBSSxZQUFZLEVBQVksQ0FBQztJQUN0RCxDQUFDO0lBQ00sbURBQWUsR0FBdEI7UUFDSSxJQUFJLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDM0MsQ0FBQztJQWJRO1FBQVIsS0FBSyxFQUFFO2tDQUFrQixRQUFROytEQUFDO0lBQzFCO1FBQVIsS0FBSyxFQUFFOztrRUFBcUM7SUFDbkM7UUFBVCxNQUFNLEVBQUU7a0NBQXVCLFlBQVk7b0VBQVc7SUFIOUMseUJBQXlCO1FBTnJDLFNBQVMsQ0FBQztZQUNQLFFBQVEsRUFBRSxtQkFBbUI7WUFDN0IsUUFBUSxFQUFFLE9BQU8sQ0FBQyxvQ0FBb0MsQ0FBQztZQUN2RCxNQUFNLEVBQUUsQ0FBQyxPQUFPLENBQUMsb0NBQW9DLENBQUMsQ0FBQztTQUMxRCxDQUFDOztPQUVXLHlCQUF5QixDQWVyQztJQUFELGdDQUFDO0NBQUEsQUFmRCxJQWVDO1NBZlkseUJBQXlCIn0=